import React, { useState, useContext, useEffect } from 'react';
import acm from '../AddCarModal.module.css'
import Select from "react-select";

import Container from "../../../../../assets/Icon/Container";

import { selectStyle } from './selectStyle';
import MultiSelect from '../../../../UI/Inputs/MultiSelect';
import CalcMultiSelect from '../../../../UI/Inputs/CalcMultiSelect';
import { AppContext } from "../../../../../providers/appProvider";
import DateSelect from '../../../../UI/Inputs/DateSelect';
import { useAuth } from '../../../../../providers/authProvider';
import { useUpdateEffect } from '../../../../../hooks/useUpdateEffect';
import { useTranslation } from 'react-i18next';

const AddCarForm = ({ newCar, setNewCar, validates, isAdd }) => {
    const { t } = useTranslation();
    
    const { appState, app } = useContext(AppContext);
    const statuses = appState.statuses.map((status) => ({ value: status.id, label: status.name }));
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));

    // Use calculator_prices only for COPART.COM (id: 1) and IAAI.COM (id: 3)
    const useCalculatorPrices = newCar.website_id === 1 || newCar.website_id === 3;
    const priceSource = useCalculatorPrices ? appState.calculator_prices : appState.prices;

    const filteredPrices = priceSource.filter(price =>
        price.website && price.website.id === newCar.website_id
    );

    const distinctPrices = [];
    const seenCityIds = new Set();

    filteredPrices.forEach(price => {
        if (!seenCityIds.has(price.location_city.id)) {
            seenCityIds.add(price.location_city.id);
            distinctPrices.push(price);
        }
    });

    if (newCar.transport_price != null  &&  !filteredPrices.some(obj => obj.id === newCar.transport_price.id)) {
     
        var price_t = newCar.transport_price
        const newPrice = {
            ...price_t,
            location_city: {
              ...price_t.location_city,
              name: price_t.location_city.name +  ' (Archive)'
            }
          };
          

        distinctPrices.push(newPrice);
    }

    const prices = distinctPrices.map(price => ({
        value: price.id,
        label: `${price.location_city?.name}`
    }));

    

    const getTransportPrice = (transport_price_id, reciever_city_id) => {
        return new Promise((resolve, reject) => {
             const initialResult = priceSource.find(entry => entry.id === transport_price_id);
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            }
    
            const location_city_id = initialResult.location_city.id;
            const website_id = initialResult.website.id;
    
             const finalResult = priceSource.find(
                entry => entry.location_city.id === location_city_id && 
                         entry.website.id === website_id && 
                         entry.reciever_city.id === reciever_city_id
            );
    
            if (finalResult) {
                resolve(finalResult);
            } else { 
                reject(new Error('Not found final Price entry by location_city.id, website.id, and reciever_city.id'));
            }
        });
    };

    useUpdateEffect(() => {

        if (newCar.reciever_city_id > 0 && newCar.transport_price_id > 0) {
             const priceResponse = getTransportPrice(newCar.transport_price_id, newCar.reciever_city_id)
            priceResponse.then(result => {
                 setNewCar(prevState => ({
                    ...prevState,
                    car_price_transport: result.company_price  ,
                    saler_price_transport: result.company_price + result.website.company_win ,
                    car_price_internal: result.internal_price ,
                    saler_price_internal: result.internal_price ,
                }))
            })
                .catch(err => {
                    setNewCar(prevState => ({
                        ...prevState,
                        car_price_transport: 0,
                        saler_price_transport: 0,
                        car_price_internal: 0,
                        saler_price_internal: 0,
                    }))
                });
        } else {
            setNewCar(prevState => ({
                ...prevState,
                car_price_transport: 0,
                saler_price_transport: 0,
                car_price_internal: 0,
                saler_price_internal: 0,
            }))
        }
    }, [newCar.reciever_city_id, newCar.transport_price_id]);
    
     /*useUpdateEffect(() => {
        setNewCar(prevState => ({
            ...prevState,
            transport_price_id: 0 
        }));
      }, [newCar.website_id]);*/

    const { session } = useAuth(AppContext)
    const onChangeStatus = (statusId) => {
        var statusN = Number(statusId);
        setNewCar(prevState => ({
            ...prevState,
            status_id: statusN ? statusN : 0,
        }));
    };

    const handleSenderDateChange = (date) => {
        setNewCar(prevState => ({
            ...prevState,
            sender_at: date ? date : "",
        }));
    };

    const handleRecieverDateChange = (date) => {
        setNewCar(prevState => ({
            ...prevState,
            reciever_at: date ? date : "",
        }));
    };


    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };


    function findTransportPriceString(prices, transport_price_id) {
         const price = prices.find(p => p.id === transport_price_id);
   
         if (price && price.sender_country && price.sender_city) {
            return `${price.sender_city.name}`;
        }
    
         return "";
    }
     
    const senderPort = findTransportPriceString(priceSource, newCar.transport_price_id);
     
    return (
        <fieldset className={acm.formField}>
            <legend>{t('Transportation')}</legend>



            <div className={acm.inp2colCar}>
                <div style={{ width: "50%" }}>

                    <div className={acm.bigtran}>
                        <div className={acm.horTitle}>
                            {t('Location')}
                        </div>
                        <Select
                            styles={validates && validates.transport_price_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={prices}
                            value={prices.find(option => option.value === newCar.transport_price_id) || null}
                            onChange={(selectedOption) => {
                                setNewCar(prevState => ({
                                    ...prevState,
                                    transport_price_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                            placeholder={t('City')}
                        />
                    </div>
                
                </div>
                <div style={{ width: "50%" }}>
                    <div className={acm.bigtran}>
                        <div className={acm.inputDownPort} >
                            {senderPort}
                        </div>
                    </div>
                    
                
                </div>
            </div>
 
 

            
            <div className={acm.bigtran}>
                <div className={acm.horTitle}>
                    {t('ReceivingPort')}
                </div>
                <div className={acm.inp2colCar}>


                    <CalcMultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newCar.reciever_country_id}
                        childId={newCar.reciever_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewCar(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder={t('Country')}
                        placeholderSub={t('Port')}
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    />

                </div>
            </div>

            <div className={acm.bigtran}>
                <div className={acm.horTitle}>
                    {t('Export')}   
                </div>
                <div className={acm.inp2colCar}> 

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newCar.export_country_id}
                        childId={newCar.export_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (export_country_id, export_city_id) => {
                            setNewCar(prevState => ({
                                ...prevState,
                                export_country_id: export_country_id ? export_country_id : 0,
                                export_city_id: export_city_id ? export_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder={t('Country')}
                        placeholderSub={t('City')}
                    />

                </div>
            </div>

            {app.hasPermission("TRANSPORT_FORM_ADDITIONS_SHOW") && 
             <>
            <div className={acm.inp2colCar}>
                <div style={{ width: "50%" }}>
                    <DateSelect
                        defDate={newCar.sender_at}
                        onChange={handleSenderDateChange}
                        placeholderText={t('SendAt')}
                        popperClassName={acm.dataContainer}
                        wrapperClassName={acm.dataContainer}
                        className={acm.input + ' ' + acm.arriveAnput}
                    />
                </div>

                <div style={{ width: "50%" }}>

                    <DateSelect
                        defDate={newCar.reciever_at}
                        onChange={handleRecieverDateChange}
                        placeholderText={t('ReceivedAt')}
                        popperClassName={acm.dataContainer}
                        wrapperClassName={acm.dataContainer}
                        className={acm.input + ' ' + acm.reciveAnput}
                    />
                </div>
            </div>


            <div className={acm.inp2colCar}>

                <div style={{ width: "50%" }}>
                    <Select
                        styles={selectStyle}
                        placeholder={t('MarineLine')}
                        options={marines}
                        value={marines.find(option => option.value === newCar.marine_line_id)}
                        onChange={(selectedOption) => {
                            setNewCar(prevState => ({
                                ...prevState,
                                marine_line_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                </div>

                <div style={{ width: "50%" }}>
                    <div className={acm.groupInput} style={{ marginBottom: "0" }}>
                        <div className={acm.groupInputIcon}>
                            <input
                                type="textS"
                                className={acm.input}
                                placeholder={t('Container')}
                                value={newCar.container_number || ''}
                                disabled={!newCar.marine_line_id}
                                onChange={(event) => {
                                    setNewCar(prevState => ({
                                        ...prevState,
                                        container_number: event.target.value,
                                    }));
                                }}
                                autoComplete="nope"
                            />
                            <div className={acm.crmIcon}>
                                <Container />
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div className={acm.inp2colCar} >
                <div style={{ width: "50%" }}>
                    <input
                        type="textS"
                        className={acm.input}
                        placeholder={t('BLNumber')}
                        value={newCar.bl_number || ''}
                            disabled={!newCar.marine_line_id}
                        onChange={(event) => {
                            setNewCar(prevState => ({
                                ...prevState,
                                bl_number: event.target.value,
                            }));
                        }}
                        autoComplete="nope"
                    />
                </div>
                <div style={{ width: "50%" }}>
                    {isAdd === false &&
                        <Select
                            styles={validates && validates.status_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={statuses}
                            value={statuses.find(option => option.value === newCar.status_id)}
                            isDisabled={!app.hasPermission("STATUS_EDIT")}
                            onChange={(selectedOption) => {
                                setNewCar(prevState => ({
                                    ...prevState,
                                    status_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                            placeholder={t('Status')} />
                    }

                </div>
            </div>

  </>
                }



        </fieldset>
    );
};

export default AddCarForm;